import useActionsCustomerProfileAdvancedForm from './useActionsCustomerProfileAdvancedForm'

export default useActionsCustomerProfileAdvancedForm
